import { createFileRoute, redirect } from "@tanstack/react-router";
import { BrowseMarketplaceTab } from "./-internal/BrowseMarketplaceTab";
import { PageContentContainer } from "@/shared/components/PageContentContainer";
import { buyFilterSearchSchema, cleanBrowseSearch } from "./-internal/types";

export const Route = createFileRoute("/buy/")({
  component: RouteComponent,
  validateSearch: buyFilterSearchSchema,
  beforeLoad: ({ location }) => {
    const clean = cleanBrowseSearch(location.search);
    if (JSON.stringify(clean) !== JSON.stringify(location.search)) {
      throw redirect({ to: "/buy", search: clean, replace: true });
    }
  },
});

function RouteComponent() {
  return (
    <PageContentContainer>
      <BrowseMarketplaceTab />
    </PageContentContainer>
  );
}
